import { ColDef } from 'ag-grid-community';
import { AgGridActionCellParams, AgGridActionCellRenderer } from '../ag-grid-action-cell/ag-grid-action-cell.component';

export interface GuiaGridColumnHandlers {
  onOpenGuia: (cdGuiaMonitor: string, data?: any, extraParams?: any) => void;
  onOpenPrimeiroLancto?: (cdGuiaMonitor: string, data?: any, extraParams?: any) => void;
}

function buildActionParams(
  actionFunction: (value: any, data: any, extraParams?: any) => void,
  extraParams?: any,
): AgGridActionCellParams {
  return {
    actionTooltip: 'Exibir detalhes da guia',
    extraParams,
    actionFunction,
  };
}

export function buildGuiaGridColumns(handlers: GuiaGridColumnHandlers): ColDef[] {
  return [
    {
      headerName: '006-Registro ANS',
      field: 'cd_registro_ans',
      hide: true,
    },
    {
      headerName: '020-Nr. plano na ANS',
      field: 'nr_registro_plano',
      width: 200,
    },
    {
      headerName: 'Cód. lancto',
      field: 'cd_guia_monitor',
      cellRenderer: AgGridActionCellRenderer,
      cellRendererParams: buildActionParams((value, data, extraParams) =>
        handlers.onOpenGuia(value, data, extraParams),
      ),
      type: 'str',
      sort: 'asc',
      sortIndex: 1,
      width: 200,
    },
    {
      headerName: '003-Competência',
      field: 'nr_competencia',
      type: 'competencia',
      sort: 'asc',
      sortIndex: 0,
      width: 200,
    },
    {
      headerName: '009-ID Tipo registro',
      field: 'nm_tp_registro',
      width: 200,
    },
    {
      headerName: 'Situação na ANS',
      field: 'nm_st_guia_ans',
    },
    {
      headerName: '024-Nr. guia operadora',
      field: 'nr_guia_operadora',
      type: 'str',
      width: 200,
    },
    {
      headerName: '023-Nr. guia prestador',
      field: 'nr_guia_prestador',
      type: 'str',
      width: 200,
    },
    {
      headerName: '025-ID reembolso ou pagto eventual',
      field: 'nr_reembolso',
      type: 'str',
      width: 280,
    },
    {
      headerName: '013-Tipo docto - CNPJ ou CPF',
      field: 'nm_id_cnpj_cpf_exec',
      width: 280,
    },
    {
      headerName: '066-Cód. procedimento ou item',
      field: 'cd_proced_item',
      width: 280,
    },
    {
      headerName: '014-CNPJ/CPF executante',
      field: 'nr_cnpj_cpf_exec',
      type: 'cpfCnpj',
      width: 200,
    },
    {
      headerName: '080-Data processamento',
      field: 'dt_processamento',
      type: 'date',
      width: 200,
    },
    {
      headerName: 'Seq. guia',
      field: 'nr_seq_guia',
    },
    {
      headerName: 'Cód. primeiro lancto',
      field: 'cd_guia_monitor_primeiro_lancto',
      cellRenderer: AgGridActionCellRenderer,
      cellRendererParams: buildActionParams(
        (value, data, extraParams) => (handlers.onOpenPrimeiroLancto ?? handlers.onOpenGuia)(value, data, extraParams),
        { hideNavigation: true },
      ),
      width: 200,
    },
    {
      headerName: '022-Origem da guia',
      field: 'nm_id_origem_guia',
      width: 200,
    },
    {
      headerName: '021-Tipo de guia',
      field: 'nm_tp_guia',
      width: 200,
    },
    {
      headerName: 'Tipo de rede',
      field: 'nm_tp_rede',
      width: 200,
    },
    {
      headerName: '029-Data realização',
      field: 'dt_realizacao',
      type: 'date',
      width: 200,
    },
    {
      headerName: '045-Tipo de atendimento',
      field: 'nm_tp_atendimento',
      width: 200,
    },
    {
      headerName: '123-Regime atendimento',
      field: 'nm_id_regime_atendimento',
      width: 200,
    },
    {
      headerName: '035-Cód. CBO executante',
      field: 'nr_cbo_exec',
      width: 200,
    },
    {
      headerName: '050-Valor informado da guia',
      field: 'vl_guia_informado',
      type: 'money',
      width: 280,
    },
    {
      headerName: '058-Valor total glosa',
      field: 'vl_glosa',
      type: 'money',
      width: 200,
    },
    {
      headerName: '033-Data pagamento',
      field: 'dt_pagto',
      type: 'date',
      width: 200,
    },
    {
      headerName: '059-Valor total pago',
      field: 'vl_pago',
      type: 'money',
      width: 200,
    },
    {
      headerName: '002-Nr. lote',
      field: 'nr_lote',
      width: 200,
      valueFormatter: params => params?.value?.toString().padStart(4, '0'),
    },
  ];
}
